import { TabPanelStyled } from "../../styles/StyledComponents/CommonTabWrap";
import { ITabPanelProps } from "../interface";

const TabPanel: React.FC<ITabPanelProps> = ({
  children,
  value,
  index,
  orientation = "vertical",
  ...other
}) => (
  <TabPanelStyled
    className="tabPanel_wrap"
    orientation={orientation}
    role="tabpanel"
    hidden={value !== index}
    id={`custom-tabpanel-${index}`}
    aria-labelledby={`custom-tab-${index}`}
    {...other}
  >
    {value === index && <>{children}</>}
  </TabPanelStyled>
);

export default TabPanel;
